export function humanizeName(input) {
  if (typeof input !== 'string') return input;
  return input
    .replace(/[._]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

